import { render, staticRenderFns } from "./NoticeLeft.vue?vue&type=template&id=28c40190&scoped=true&"
import script from "./NoticeLeft.vue?vue&type=script&lang=js&"
export * from "./NoticeLeft.vue?vue&type=script&lang=js&"
import style0 from "./NoticeLeft.vue?vue&type=style&index=0&id=28c40190&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28c40190",
  null
  
)

export default component.exports